import { Component, Input, Output, EventEmitter } from '@angular/core';
import { Application, APPLICATION_TYPE_LABELS, ApplicationStatus, ApplicationType } from 'app/models/application';

@Component({
  selector: 'app-application-card',
  templateUrl: './application-card.component.html',
  styleUrls: ['./application-card.component.scss']
})
export class ApplicationCardComponent {
  @Input() applications: Application[] = [];
  @Input() applicationType!: ApplicationType;
  @Input() cardTitle: string = '';
  @Input() cardDescription: string = '';
  @Input() allowMultiple: boolean = false;
  @Output() applyClicked = new EventEmitter<ApplicationType>();
  @Output() viewClicked  = new EventEmitter<string>();
  @Output() editClicked  = new EventEmitter<Application>();

  private readonly STATUS_LABELS: Record<string, string> = {
    draft: 'Draft',
    pending: 'Pending',
    eligible: 'Eligible',
    not_eligible: 'Not Eligible',
    voted: 'Voted',
    proactive: 'Proactive',
  };

  private readonly STATUS_BADGE_CLASSES: Record<string, string> = {
    draft: 'label-default',
    pending: 'label-warning',
    eligible: 'label-success',
    not_eligible: 'label-danger',
    voted: 'label-info',
    proactive: 'label-primary',
  };

  get typeLabel(): string {
    return APPLICATION_TYPE_LABELS[this.applicationType] || this.applicationType;
  }

  get canApply(): boolean {
    return this.allowMultiple || this.applications.length === 0;
  }

  statusLabel(status?: ApplicationStatus): string {
    return this.STATUS_LABELS[status || ''] || '';
  }

  statusBadgeClass(status?: ApplicationStatus): string {
    return this.STATUS_BADGE_CLASSES[status || ''] || 'label-default';
  }

  applicationId(application: Application): string {
    const raw: any = application._id;
    return raw?.['$oid'] ?? String(raw);
  }

  onApply(): void {
    this.applyClicked.emit(this.applicationType);
  }

  onView(application: Application): void {
    this.viewClicked.emit(this.applicationId(application));
  }

  onEdit(application: Application): void {
    this.editClicked.emit(application);
  }
}
